import { useEffect, useState } from "react";
import { IPaymentDetails, ITransaction } from "../../interface/ITransactionHistory";
import { getPaymentDetailsRoute } from "@api-routes/payments";
import { useFetch } from "@common/hook/useFetch";

export const useGetPaymentDetails = (
    paymentCorrelationTransactionUuid: ITransaction["paymentCorrelationTransactionUuid"]
) => {
    const [paymentDetails, setPaymentDetails] = useState<IPaymentDetails>();
    const [getPaymentDetailsState, { get }] = useFetch();

    useEffect(() => {
        get<IPaymentDetails>(getPaymentDetailsRoute(paymentCorrelationTransactionUuid)).then(setPaymentDetails);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paymentCorrelationTransactionUuid]);

    return { paymentDetails, getPaymentDetailsState };
};
